import { ICallback } from '../interfaces/ICallback';

const setImmediateTimeout = (callback: ICallback): number => window.setTimeout(callback, 0);

export default setImmediateTimeout;
